module.exports = __webpack_public_path__ + "static/media/money_bonus_1.643b3df7.webp";